export default {
  EMAIL: {
    label: { text: 'E-mail' },
    name: 'email',
    placeholder: 'Insira seu e-mail',
    as: 'input',
    type: 'email',
    rules: 'required|email',
  },
  PASSWORD: {
    label: { text: 'Senha' },
    name: 'password',
    placeholder: 'Insira sua senha',
    as: 'input',
    type: 'password',
    maxlength: 50,
    rules: 'required|min:8|max:50',
  },
  FULLNAME: {
    label: { text: 'Nome completo' },
    name: 'name',
    placeholder: 'Digite seu nome',
    as: 'input',
    type: 'text',
    rules: 'required|only-letters|fullname',
  },
  PHONE: {
    label: { text: 'Celular' },
    name: 'phone',
    placeholder: '(11) 99999-9999',
    as: 'input',
    autocomplete: 'off',
    inputmode: 'numeric',
    type: 'tel',
    mask: ['(##) ####-####', '(##) #####-####'],
    rules: 'required|phone',
  },
  LGPD: {
    label: { text: 'Quero receber ofertas e novidades da Finclass.' },
    name: 'lgpd',
    type: 'checkbox',
    checked: true,
  },
  CPF: {
    label: { text: 'CPF' },
    name: 'userDocument',
    inputmode: 'numeric',
    placeholder: 'Digite o CPF do titular do cartão',
    as: 'input',
    type: 'text',
    maxlength: 14,
    rules: 'required|max:14|cpf',
    mask: ['###.###.###-##'],
  },
  CC_NUMBER: {
    label: { text: 'Número do cartão' },
    name: 'number',
    placeholder: 'Digite o número do cartão',
    as: 'input',
    type: 'text',
    inputmode: 'numeric',
    maxlength: 19,
    rules: 'required|max:19|credit-card',
    mask: ['#### #### #### ####', '#### ###### #####'],
  },
  CC_CVV: {
    inputmode: 'numeric',
    label: {
      text: 'CVV',
      tooltip: {
        text: 'CVV é um código de segurança de 3 dígitos, impresso no verso de cartões de crédito.',
        iconName: 'card',
      },
    },
    name: 'cvv',
    as: 'input',
    type: 'text',
    maxlength: 4,
    rules: 'required|only-numbers|max:4',
  },
  EXPIRY: {
    label: { text: 'Validade mm/aaaa' },
    name: 'expiry',
    inputmode: 'numeric',
    placeholder: 'MM/AAAA',
    as: 'input',
    type: 'text',
    maxlength: 7,
    rules: 'required|max:7|expiration-date',
    mask: ['##/####'],
  },
  CPF_CNPJ: {
    label: { text: 'CPF ou CNPJ' },
    name: 'document',
    placeholder: 'Digite o CPF/CNPJ neste campo',
    as: 'input',
    type: 'text',
    minlength: 14,
    maxlength: 18,
    rules: 'required|min:14|max:18|cpf-cnpj',
    mask: ['###.###.###-##', '##.###.###/####-##'],
  },
  INSTALLMENTS: {
    label: { text: 'Número de Parcelas' },
    name: 'installments',
    type: 'select',
    options: [],
    disabled: false,
    placeholder: '',
  },
  ZIPCODE: {
    label: { text: 'CEP' },
    name: 'zipcode',
    placeholder: 'Informe seu CEP',
    as: 'input',
    type: 'text',
    minlength: 9,
    maxlength: 9,
    rules: 'required|min:9|max:9|cep',
    mask: ['#####-###'],
  },
  STREET: {
    label: { text: 'Rua' },
    name: 'street',
    placeholder: 'Informe sua rua',
    as: 'input',
    type: 'text',
    minlength: 5,
    maxlength: 50,
    rules: 'required|min:8|max:50',
  },
  NEIGHBORHOOD: {
    label: { text: 'Bairro' },
    name: 'neighborhood',
    placeholder: 'Informe seu bairro',
    as: 'input',
    type: 'text',
    minlength: 5,
    maxlength: 50,
    rules: 'required|min:8|max:50',
  },
  NUMBER: {
    label: { text: 'Número' },
    name: 'number',
    placeholder: 'Insira o número',
    as: 'input',
    type: 'number',
    min: 1,
    max: 1000,
    rules: 'required|only-numbers|min:1|max:10',
  },
  COMPLEMENT: {
    label: { text: 'Complemento' },
    name: 'complement',
    placeholder: 'Complemento (opcional)',
    as: 'input',
    type: 'text',
    minlength: 5,
    maxlength: 20,
    rules: 'min:5|max:20',
  },
  CITY: {
    label: { text: 'Cidade' },
    name: 'city',
    placeholder: 'Insira a cidade',
    as: 'input',
    type: 'text',
    minlength: 3,
    maxlength: 50,
    rules: 'required|min:3|max:50',
  },
};
